// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: note.proto

export const protobufPackage = 'compasspb';

/** NoteType represents the type of note being created. */
export enum NoteType {
  /** NOTE_TYPE_UNSPECIFIED - Default/unknown type - treated as general note */
  NOTE_TYPE_UNSPECIFIED = 0,
  /** NOTE_TYPE_GENERAL - General note with no associated action */
  NOTE_TYPE_GENERAL = 1,
  /** NOTE_TYPE_STATE_CHANGED - Note associated with a state/status change action */
  NOTE_TYPE_STATE_CHANGED = 2,
  /** NOTE_TYPE_ASSIGNMENT_CHANGED - Note associated with an assignee change */
  NOTE_TYPE_ASSIGNMENT_CHANGED = 3,
}

/**
 * StateChangedData contains information about a state change action.
 * This is populated when a note is associated with a status/state transition.
 */
export interface StateChangedData {
  /** The action that triggered the state change (e.g., "mark_as_completed", "call_with_human") */
  action?: string | undefined;
}

/**
 * AssignmentChangedData contains information about an assignee change.
 * This is populated when a note is associated with an assignment update.
 */
export interface AssignmentChangedData {
  /** Email of the previous assignee (empty string if was unassigned) */
  from_user?: string | undefined;
  /** Email of the new assignee */
  to_user?: string | undefined;
}

/** NoteInfo represents the public view of a note record. */
export interface NoteInfo {
  /** Unique identifier for the note */
  id?: string | undefined;
  /** ID of the case record this note is associated with */
  case_record_id?: string | undefined;
  /** Type of note (general, state_changed, assignment_changed) */
  type?: NoteType | undefined;
  /** Content of the note */
  content?: string | undefined;
  /** State change data (only populated for NOTE_TYPE_STATE_CHANGED) */
  state_changed?: StateChangedData | undefined;
  /** Assignment change data (only populated for NOTE_TYPE_ASSIGNMENT_CHANGED) */
  assignment_changed?: AssignmentChangedData | undefined;
  /** User ID of the note creator (use GetUser API to fetch name/email) */
  created_by?: string | undefined;
  /** Timestamp when the note was created */
  created_at?: string | undefined;
  /** Timestamp when the note was last updated */
  updated_at?: string | undefined;
}

/**
 * CreateNoteRequest is used to create a new general note for a case record.
 * Status change and assignee change notes are created internally by the system.
 */
export interface CreateNoteRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Content of the note */
  content?: string | undefined;
}

/** CreateNoteResponse returns the newly created note. */
export interface CreateNoteResponse {
  note?: NoteInfo | undefined;
}

/** ListNotesRequest is used to retrieve all notes for a case record. */
export interface ListNotesRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Optional filter by note type */
  type?: NoteType | undefined;
  /** Maximum number of notes to return (pagination) */
  limit?: number | undefined;
  /** Cursor for pagination - ID of the last note from previous page */
  start_after_id?: string | undefined;
}

/** ListNotesResponse returns a paginated list of notes. */
export interface ListNotesResponse {
  notes?: NoteInfo[] | undefined;
  /** Total number of notes available (across all pages) */
  total?: number | undefined;
}

/**
 * NoteService provides operations for managing notes on case records.
 * Notes can be general comments, status change annotations, or assignee change annotations.
 */
export interface NoteService {
  /** CreateNote creates a new general note for a case record. */
  createNote(request: CreateNoteRequest): Promise<CreateNoteResponse>;
  /** ListNotes retrieves all notes for a case record. */
  listNotes(request: ListNotesRequest): Promise<ListNotesResponse>;
}
